export default __webpack_public_path__ + "static/media/bed.b551e27b.svg";